import { MarkCodeTextInputModel } from '../mark-code-text-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マーク(コード)リスト取得クラス
 *
 * @export GetMarkListService
 * @class GetMarkListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMarkListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: MarkCodeTextInputModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMarkListService
   */
  execute(model: MarkCodeTextInputModel, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getMarkList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkListService
   */
  success(data: any): void {
    this.model.updateMarkList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
